import React from 'react';
import '../css/Card.css';

const TopCard = (props) => {
    return (
        <div className='top-card-container flex-center'>
            <div className={`title-container ${props.position === 'bottom' ? 'hidden' : ''} subtle-shadow`}>
                <div className='title bold outfit'>
                    {props.title}
                </div>
            </div>
            <div className='image-container'>
                <div className={`image home02-programs-image ${props.image} ${props.position === 'top' ? 'overlap' : ''} subtle-shadow`}/>
            </div>
            <div className={`title-container ${props.position === 'top' ? 'hidden' : 'overlap'}`}>
                <div className={`title bold outfit`}>
                    {props.title}
                </div>
            </div>
        </div>
    );
};

export default TopCard;